import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingTextToSpeechConfig } from '@/data/landingConfig/landingTextToSpeechConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_TextToSpeech } from './schemaObject';

interface Props {}
const TextToSpeech: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_TextToSpeech} />
			<LandingTemplate
				data={landingTextToSpeechConfig}
				funnelLinkService={GenerateLandingLinkService.funnelVoiceGenerator()}
			/>
		</>
	);
};

export default TextToSpeech;
